<span
  [style.backgroundColor]="backgroundColorCss"
  [style.display]="displayCss"
  class="iu-input-text-ui"
  [style.margin-top.px]="data && data.marginTop > 0 ? data.marginTop : null">
  <p style="font-size: 14px; margin: 5px" [innerHTML]="fieldValue | safeHtml"></p>
</span>
